import { render, staticRenderFns } from "./CompositionProperty.vue?vue&type=template&id=d074f9da&"
import script from "./CompositionProperty.vue?vue&type=script&lang=js&"
export * from "./CompositionProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports